export default __webpack_public_path__ + "static/media/Wolfsbane.d87811e4.jpg";